import {
  externalApi,
  localApi,
  wpApi,
} from '../../../shared/config/axiosConfig';
import { fetchFileFromServerApi } from '../../../services/webAPI/webAPI.object.service';
import store from '../../store';
import * as qs from 'qs';
import {
  FETCH_FILE_REQUEST,
  FETCH_FILE_RESULT,
  FETCH_FILE_ERROR,
} from '../../types/user';
import {
  OBJECT_DOWNLOAD_ERROR,
  OBJECT_DOWNLOAD_PROGRESS,
  OBJECT_UPLOAD_ERROR,
  OBJECT_UPLOAD_PROGRESS,
} from '../../types/object';
import {
  downloadFromUrl,
  logDebug,
  logTrace,
} from '../../../shared/config/globalFunctions';
import { useDispatch } from 'react-redux';
import { GetFileJsonFromAPI as getFileJsonFromAPI } from '../../../services/webAPI/webApi.file.service';
import { GetFileJsonFromHub as getFileJsonFromHub } from '../../../services/desktopApp/desktopApp.object.service';
import { GetGuidFromID } from '../../../shared/helper';

/** @typedef {import('../../../../global').ObjectUploadProgressEvent} ObjectUploadProgressEvent */
/** @typedef {import('../../../../global').ObjectDownloadProgressEvent} ObjectDownloadProgressEvent */
/** @typedef {import('redux-thunk').ThunkDispatch} ThunkDispatch */
/** @typedef {import('../../../../global').ObjectJSON_1_1_2} ObjectJSON_1_1_2 */

/**
 * @template t1, t2, t3, t4
 * @typedef {import('redux-thunk').ThunkAction<t1,t2,t3,import('redux').Action>} ThunkAction
 */

/**
 *
 * @returns
 */
export const fetchFileFromServer =
  (file, type, isGIMTransfer) => async (dispatch) => {
    dispatch({ type: FETCH_FILE_REQUEST });
    try {
      const response = await fetchFileFromServerApi(file, type, isGIMTransfer); // <- Service or API function
      dispatch({ type: FETCH_FILE_RESULT, payload: response });
      return response;
    } catch (e) {
      dispatch({ type: FETCH_FILE_ERROR, error: e });
      throw e;
    }
  };

/**
 * @param {ObjectUploadProgressEvent} progressData The data of the object's progress
 * @returns {(dispatch: ThunkDispatch) => void}
 */
export const UpdateObjectUploadProgress = (progressData) => (dispatch) => {
  //logTrace('received some progress bar data HERES', progressData);
  if (progressData.okay)
    dispatch({
      type: OBJECT_UPLOAD_PROGRESS,
      payload: {
        guid: progressData.guid,
        name: progressData.name,
        type: 'upload',
        progress: progressData.progress,
        text: progressData.text,
      },
    });
  else
    dispatch({
      type: OBJECT_UPLOAD_ERROR,
      payload: {
        guid: progressData.guid,
        name: progressData.name,
        type: 'upload',
        error: progressData.error,
        text: progressData.text,
      },
    });
};

/**
 * @param {ObjectDownloadProgressEvent} progressData The data of the object's progress
 * @returns {(dispatch: ThunkDispatch) => void}
 */
export const UpdateObjectDownloadProgress = (progressData) => (dispatch) => {
  if (progressData.okay)
    dispatch({
      type: OBJECT_DOWNLOAD_PROGRESS,
      payload: {
        guid: progressData.guid,
        name: progressData.name,
        type: 'download',
        progress: progressData.progress,
        text: progressData.text,
      },
    });
  else
    dispatch({
      type: OBJECT_DOWNLOAD_ERROR,
      payload: {
        guid: progressData.guid,
        name: progressData.name,
        type: 'download',
        error: progressData.error,
        text: progressData.text,
      },
    });
};

/**
 *
 * @returns
 */
export const checkFileForDirectDownload = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'GET',
    url: `/object/CheckExistFile?filename=${data}`,
    data,
  });
  return response;
};

/**
 *
 * @returns
 */
export const getTestResult = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'GET',
    url: `/object/GetTestResult${data}`,
  });
  return response;
};

/**
 *
 * @returns
 */
export const updateTestResult = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: '/object/AddUpdateTestResult',
    data,
  });
  return response;
};

// Test result
/**
 *
 * @returns
 */
export const getTestFileList = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'GET',
    url: '/object/GetTestFileList',
  });
  return response;
};
/**
 *
 * @returns
 */
export const getTestVersionList = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'GET',
    url: '/object/GetVersionList',
  });
  return response;
};

/**
 *
 * @returns
 */
export const getLocationList = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'GET',
    url: `/Project/GetObjectLocationList?${data}`,
  });
  return response;
};

/**
 *
 * @returns
 */
export const getLocationById = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'GET',
    url: `/Project/GetObjectLocationById?${data}`,
  });
  return response;
};

/**
 *
 * @returns
 */
export const addObjectLocation = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: '/Project/AddObjectLocation',
    data,
  });
  return response;
};

/**
 *
 * @returns
 */
export const updateObjectLocation = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: '/Project/UpdateObjectLocation',
    data,
  });
  return response;
};

/**
 *
 * @returns
 */
export const deleteObjectLocation = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: '/Project/DeleteObjectLocation',
    data,
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const getObjectByPlotId = (data) => async (dispatch) => {
  try {
    const response = await externalApi({
      method: 'GET',
      url: `Project/GetObjectIdsByPlotId?${data}`,
    });
    return response?.data;
  } catch (e) {
    // if (response.data.projects) {
  }
};

/**
 *
 * @returns
 */
export const getTransferObject = (data) => async (dispatch) => {
  try {
    const response = await externalApi({
      method: 'GET',
      url: `object/GetGIMTransferObject?${data}`,
    });
    return response?.data;
  } catch (e) {
    // if (response.data.projects) {
  }
};

/**
 *
 * @returns
 */
export const getObjectGLBModelsBatch = (data) =>
  externalApi.get('object/GetBatchGLBObjectModels', {
    params: data,
    paramsSerializer: function (params) {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
  });

// async (data) =>{
//   const response = await externalApi({
//     method: "GET",
//     url: `object/GetBatchGLBObjectModels`,
//     params: data,
//   })

//   return response?.data
// }

/**
 *
 * @returns
 */
export const getObjects = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: 'object/GetObjectSearch',
    data,
  });

  return response.data?.Result;
};

/**
 *
 * @returns
 */
export const addObject = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: 'object/AddObjectData',
    data,
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const postObjectData = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: 'object/PostObjectData',
    data,
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const deleteObject = async (data) => {
  const response = await externalApi({
    method: 'POST',
    url: 'object/DeleteObject',
    data,
  });
  return response.data;
};

/**
 * Clears soft-delete on an object (list visibility). Same payload as deleteObject.
 * Pair with CoreWebApi POST object/RestoreObject — does not restore map placement.
 * @param {{ ObjectID: number, ProjectId: number, SubprojectId?: number, userId: number }} data
 * @returns {Promise<unknown>}
 */
export const restoreObject = async (data) => {
  const response = await externalApi({
    method: 'POST',
    url: 'object/RestoreObject',
    data,
  });
  return response.data;
};

/**
 *
 * @returns
 */
export const shareObjects = (data) => async (dispatch) => {
  const response = await externalApi({
    method: 'POST',
    url: 'object/SendGIMTransferLink',
    data,
  });

  return response.data?.Result;
};

/**
 *
 * @returns
 */
export const GetPromotedObjectParentDetails =
  (PID, OID) => async (dispatch) => {
    const response = await externalApi({
      method: 'GET',
      url: `/object/GetPromotedObjectParentDetails?childPID=${PID}&childOID=${OID}`,
    });
    return response;
  };

/**
 * Gets a file's Json. Attempts to get the cached version from Temp.
 * @param {string} guid The file's GUID
 * @param {(progress: number) => any} onProgress function to monitor progress (optional)
 * @param {AbortSignal} abortSignal fetch abort signal (option)
 * @returns {ThunkAction<Promise<ObjectJSON_1_1_2>, import('../../../../global').ReduxAppState, any, ()=>{}>} The json content of the object's file
 */
export const getFileJson =
  (guid, onProgress = null, abortSignal) =>
  async (_, getState) => {
    const connected = getState().desktopApp.managerReady;

    if (connected) {
      return await getFileJsonFromHub(guid, onProgress, abortSignal);
    } else {
      return await getFileJsonFromAPI(guid, onProgress, abortSignal);
    }
  };

/**
 * Gets a file's Json. Attempts to get the cached version from Temp.
 * @returns {ThunkAction<Promise<string>, import('../../../../global').ReduxAppState, any, ()=>{}>} The json content of the object's file
 */
export const DownloadAndConvertFile =
  (
    projectID,
    objectID,
    subProjectID = null,
    objectName,
    fileType,
    gimUnitSize
  ) =>
  async (dispatch, getState) => {
    const connected = getState().desktopApp.managerReady;
    if (fileType[0] === '.') fileType = fileType.slice(1);

    if (connected) {
      /** @type {import('../../../../global').DownloadFileRequest} */
      const data = {
        ObjectID: objectID,
        ProjectID: projectID,
        SubProjectID: subProjectID,
        ObjectName: objectName,
        FileType: fileType,
        GimUnitSize: gimUnitSize,
      };
      const res = await localApi({
        method: 'POST',
        url: 'DownloadAndConvertFile',
        data: data,
      });

      return res.data;
    } else {
      const guid = GetGuidFromID(projectID, objectID, subProjectID);
      const fileUrl =
        //@ts-ignore
        import.meta.env.VITE_FILEUPLOAD_DOMAIN + guid + '.' + fileType;

      logDebug(
        'GIMmanager not connected, downloading instead directly from url ',
        fileUrl
      );
      downloadFromUrl(fileUrl, objectName + '.' + fileType);
      return fileUrl;
    }
  };
